var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowsUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.167 2.333a1 1 0 0 0-.707.293L10.126 5.96a1 1 0 0 0 1.414 1.414l1.627-1.626v10.919a1 1 0 1 0 2 0V5.747l1.626 1.627a1 1 0 1 0 1.414-1.414l-3.333-3.334a1 1 0 0 0-.707-.293M5.833 6.5a1 1 0 0 0-.707.293l-3.333 3.333a1 1 0 1 0 1.414 1.415l1.626-1.627v6.753a1 1 0 1 0 2 0V9.914l1.627 1.627a1 1 0 0 0 1.414-1.415L6.54 6.793a1 1 0 0 0-.707-.293",
  clipRule: "evenodd"
})));
SvgArrowsUp.displayName = "SvgArrowsUp";
export { SvgArrowsUp as ReactComponent };
export default SvgArrowsUp;